// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2m7sR","rootSmall":"AddTileButton_rootSmall__2Mxlg"};